import BaseAPI from '../BaseAPI.js'

export default class extends BaseAPI {
  _resource ='regions'
  _parentResources =['countries']
}
